/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { getDialogInitData } from '@gh/common-shared';
import { DialogInput } from '@gh/core-ui';
import { GridDefinitionFactory, LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import {
  ContactDuplicateFilter,
  ContactDuplicateItem,
} from '../../resources/model/contact-details-common.model';

export interface ContactDuplicatesDialogConfig {
  original: ContactDuplicateItem;
  duplicateFilter: ContactDuplicateFilter;
}

@Component({
  standalone: false,
  selector: 'gh-contact-duplicates-dialog',
  templateUrl: 'contact-duplicates-dialog.component.html',
  styleUrls: ['contact-duplicates-dialog.component.scss'],
})
export class ContactDuplicatesDialogComponent implements DialogInput<ContactDuplicatesDialogConfig>, OnInit {
  input: ContactDuplicatesDialogConfig;

  duplicateData: ContactDuplicateItem[] = [];
  originalData: ContactDuplicateItem[] = [];
  gridDefinition: LayoutBasedGridDefinition;

  constructor(private dialogRef: MatDialogRef<any>,
              @Inject(MAT_DIALOG_DATA) private dialogData: any,
              private gridDefinitionFactory: GridDefinitionFactory) {
    this.gridDefinition = this.gridDefinitionFactory.buildLayoutBased({}, {
      noAutomation: true,
    });

  }

  ngOnInit(): void {
    const { duplicates, gridLayout } = getDialogInitData(this.dialogData);

    this.gridDefinition.bind(gridLayout);

    this.originalData = [this.input.original];
    this.duplicateData = duplicates;
  }
}
